import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const IngresosAlmacenApi = () => {
    const [cargando, setCargando] = useState(false);

    const getIngresosAlmacen = async (almacenInventarioId) => {
        try {
            setCargando(true);
            const response = await api.get(
                `almacen_inventario/ingresos_periodo/${almacenInventarioId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getIngresosAlmacen,

        cargando,
    };
};
